import React from 'react';
import {Button, Empty, Table, Typography} from 'antd';
import {BarChartOutlined, DownloadOutlined} from '@ant-design/icons';

const ReportResultTable = ({title, parsedReport, onDownload, summaryItems=[]}) => {
    if(!parsedReport)
        return null;

    const rows=parsedReport.rows || [];
    const columns=parsedReport.columns || [];
    const tableColumns=columns.map(column=>({
        ...column,
        width: column.width || 180
    }));
    const scrollWidth=Math.max(tableColumns.length * 180, 720);

    return (
        <div className="report-result-panel">
            <div className="report-result-header">
                <div className="report-result-heading">
                    <Typography.Title level={3}>{title || 'Resultado del reporte'}</Typography.Title>
                    <Typography.Text className="report-result-count">
                        {rows.length} registros encontrados
                    </Typography.Text>
                </div>
                <Button icon={<DownloadOutlined/>} onClick={onDownload} className="report-download-button">
                    Descargar CSV
                </Button>
            </div>
            {rows.length>0?
                <>
                    <div className="report-table-shell">
                        <div className="report-table-scroll-hint">Desliza horizontalmente para ver más columnas</div>
                        <Table
                            className="report-result-table"
                            columns={tableColumns}
                            dataSource={rows}
                            pagination={{pageSize:10, showSizeChanger:false, hideOnSinglePage:false}}
                            scroll={{x:scrollWidth}}
                            size="middle"
                            tableLayout="fixed"
                        />
                    </div>
                </>:
                <Empty description="La consulta no retornó registros para mostrar."/>
            }
            {summaryItems.length>0?
                <div className="report-summary-grid">
                    {summaryItems.map((item,index)=>(
                        <div className="report-summary-card" key={`${item.label}-${index}`}>
                            <div className="report-summary-icon"><BarChartOutlined/></div>
                            <div className="report-summary-content">
                                <span>{item.label}</span>
                                <strong>{item.value}</strong>
                            </div>
                        </div>
                    ))}
                </div>:null}
        </div>
    );
};

export default ReportResultTable;
